// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { fetchoneroute_details, routeSelector } from "../api/route";
// import { useDispatch, useSelector } from "react-redux";
// import { FaArrowLeft, FaPen } from "react-icons/fa";
// import { fetchAlllocation, locationSelector } from "../api/locations";

// const TripDetailsCard = () => {
//   const retrievedData = JSON.parse(localStorage.getItem("Selected Data"));
//   const dispatch = useDispatch();
//   const { selected_route, current_route } = useSelector(routeSelector);
//   const { all_location } = useSelector(locationSelector);
//   const [isModalOpen, setIsModalOpen] = useState(false); 

//   useEffect(() => {
//     dispatch(fetchoneroute_details(retrievedData));
//     dispatch(fetchAlllocation())
//   }, [dispatch]);

//   const convertDateFormat = (dateString) => {
//     const dateObj = new Date(dateString);
//     const day = String(dateObj.getDate()).padStart(2, "0");
//     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen); // Toggle modal
//   };
//   const getLocationName = (id) => {
//     const location = all_location?.find((loc) => loc._id === id);
//     return location ? location.name : "Unknown";
//   };


//   console.log("the all locations are:", all_location);

//   return (
//     <>
//       {/* Trip Details Card - Desktop */}
//       <div
//         className="max-w-lg rounded-3xl bg-white shadow-lg text-center hidden sm:block mx-auto"
//         style={{ fontFamily: "Nunito Sans" }}
//       >
//         <div className="bg-sky-100 p-4 rounded-t-3xl">
//           <h2 className="text-xl font-semibold">Trip Details</h2>
//         </div>
//         <div className="p-6 space-y-6">
//           <div className="space-y-1">
//             <span className="text-gray-600 text-sm">From</span>
//             <h3 className="text-2xl font-bold">{getLocationName(retrievedData?.from)}</h3>
//             <p className="text-gray-600">{retrievedData?.pickupStreet}</p>
//           </div>
//           <div className="space-y-1">
//             <span className="text-gray-600 text-sm">To</span>
//             <h3 className="text-2xl font-bold">{getLocationName(retrievedData?.to)}</h3>
//             <p className="text-gray-600">{retrievedData?.dropStreet}</p>
//           </div>
//           <div className="space-y-4">
//             <p className="text-gray-900 text-sm sm:text-base mt-1">
//               {convertDateFormat(retrievedData?.date)}
//             </p>
//             <button
//               className="w-24 bg-gradient-to-r from-blue-300 to-blue-400 text-white py-2 px-6 rounded-full hover:bg-gray-800 transition-colors"
//               onClick={toggleModal} // Open modal
//             >
//               Modify
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Trip Details Card - Mobile */}
      // <div className="flex flex-col sm:flex-row items-center justify-between p-4 bg-white shadow-md rounded-lg w-full space-y-3 sm:space-y-0 sm:space-x-4 sm:hidden mt-[-8.5rem]">
      //   {/* Left Section */}
      //   <div className="flex items-center space-x-3 w-full sm:w-auto">
      //     <div className="overflow-hidden">
      //       <h3 className="font-semibold text-black text-xl sm:text-2xl truncate leading-tight">
      //       {getLocationName(retrievedData?.from)} <span>To</span>{" "}
      //         <span>{getLocationName(retrievedData?.to)}</span>
      //       </h3>
      //       <p className="text-gray-500 text-sm sm:text-base mt-1">
      //         {convertDateFormat(retrievedData?.date)}{" "}
      //         <span className="text-gray-500 text-sm sm:text-base">10:00 AM</span>
      //       </p>
      //     </div>
      //   </div>
      //   {/* Edit Button */}
      //   <button
      //     className="text-blue-500 hover:text-blue-600 flex items-center space-x-1 transition-colors duration-300 ease-in-out"
      //     onClick={toggleModal} // Open modal
      //   >
      //     <FaPen className="text-sm sm:text-base" />
      //     <span>Modify</span>
      //   </button>
      // </div>

//       {/* Modal */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
//             <h2 className="text-lg font-semibold text-gray-800 mb-4">Modify Trip Details</h2>

//             {/* Modify Inputs */}
//             <label className="block mb-2 text-gray-700">Pickup Street:</label>
//             <input
//               type="text"
//               defaultValue={retrievedData?.pickupStreet}
//               className="w-full border border-gray-300 rounded-md px-3 py-2 mb-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//             />

//             <label className="block mb-2 text-gray-700">Drop Street:</label>
//             <input
//               type="text"
//               defaultValue={retrievedData?.dropStreet}
//               className="w-full border border-gray-300 rounded-md px-3 py-2 mb-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
//             />

//             <label className="block mb-2 text-gray-700">Date:</label>
//             <input
//               type="date"
//               defaultValue={retrievedData?.date}
//               className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
//             />

//             {/* Buttons */}
//             <div className="flex justify-end space-x-2">
//               <button
//                 className="px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
//                 onClick={toggleModal} 
//               >
//                 Cancel
//               </button>
//               <button className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default TripDetailsCard;
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaPen } from "react-icons/fa";
import { fetchAlllocation, locationSelector } from "../api/locations";
import { useNavigate } from "react-router-dom";

const TripDetailsCard = () => {
  const retrievedData = JSON.parse(localStorage.getItem("Selected Data"));
  const dispatch = useDispatch();
  const { all_location } = useSelector(locationSelector);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  // State for modal inputs
  const [formData, setFormData] = useState({
    from: retrievedData?.from || "",
    to: retrievedData?.to || "",
    pickupStreet: retrievedData?.pickupStreet || "",
    dropStreet: retrievedData?.dropStreet || "",
    date: retrievedData?.date || "",
  });

  // Search states for From and To dropdowns
  const [fromSearch, setFromSearch] = useState("");
  const [toSearch, setToSearch] = useState("");

  // Dropdown open states
  const [fromDropdownOpen, setFromDropdownOpen] = useState(false);
  const [toDropdownOpen, setToDropdownOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchAlllocation());
  }, [dispatch]);

  // Convert date format for display
  const convertDateFormat = (dateString) => {
    const dateObj = new Date(dateString);
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Toggle modal
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Get location name by ID
  const getLocationName = (id) => {
    const location = all_location?.find((loc) => loc._id === id);
    return location ? location.name : "Unknown";
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle location selection
  const handleLocationChange = (type, locationId) => {
    setFormData({ ...formData, [type]: locationId, [`${type === "from" ? "pickupStreet" : "dropStreet"}`]: "" });
    if (type === "from") {
      setFromDropdownOpen(false);
    } else {
      setToDropdownOpen(false);
    }
  };

  // Handle saving changes
  const handleSaveChanges = () => {
    const updatedData = { ...retrievedData, ...formData };
    localStorage.setItem("Selected Data", JSON.stringify(updatedData));
    toggleModal();
    navigate('/sharedcabs') 
    window.location.reload()
  };

  // Filter locations for search
  const filteredFromLocations = all_location.filter((location) =>
    location?.name.toLowerCase().includes(fromSearch.toLowerCase())
  );
  const filteredToLocations = all_location.filter((location) =>
    location?.name.toLowerCase().includes(toSearch.toLowerCase())
  );

  return (
    <>
      {/* Trip Details Card - Desktop */}
      <div
        className="max-w-lg rounded-3xl bg-white shadow-lg text-center hidden sm:block mx-auto"
        style={{ fontFamily: 'Lato, sans-serif' }}
      >
        <div className="bg-sky-100 p-4 rounded-t-3xl">
          <h2 className="text-xl font-semibold">Trip Details</h2>
        </div>
        <div className="p-6 space-y-6">
          <div className="space-y-1">
            <span className="text-gray-600 text-sm">From</span>
            <h3 className="text-2xl font-bold">{getLocationName(retrievedData?.from)}</h3>
            <p className="text-gray-600">{retrievedData?.pickupStreet}</p>
          </div>
          <div className="space-y-1">
            <span className="text-gray-600 text-sm">To</span>
            <h3 className="text-2xl font-bold">{getLocationName(retrievedData?.to)}</h3>
            <p className="text-gray-600">{retrievedData?.dropStreet}</p>
          </div>
          <div className="space-y-4">
            <p className="text-gray-900 text-sm sm:text-base mt-1">
              {convertDateFormat(retrievedData?.date)}
            </p>
            <button
              className="w-24 bg-gradient-to-r from-blue-300 to-blue-400 text-white py-2 px-6 rounded-full hover:bg-gray-800 transition-colors"
              onClick={toggleModal}
            >
              Modify
            </button>
          </div>
        </div>
      </div>
      
{/* Trip Details Card - Mobile */}
      <div className="flex flex-col sm:flex-row items-center justify-between p-4 bg-white shadow-md rounded-lg w-full space-y-3 sm:space-y-0 sm:space-x-4 sm:hidden mt-[-8.5rem] font-lato">
        {/* Left Section */}
        <div className="flex items-center space-x-3 w-full sm:w-auto">
          <div className="overflow-hidden">
            <h3 className="font-semibold text-black text-xl sm:text-2xl truncate leading-tight">
            {getLocationName(retrievedData?.from)} <span>To</span>{" "}
              <span>{getLocationName(retrievedData?.to)}</span>
            </h3>
            <p className="text-gray-500 text-sm sm:text-base mt-1">
              {convertDateFormat(retrievedData?.date)}{" "}
              <span className="text-gray-500 text-sm sm:text-base">10:00 AM</span>
            </p>
          </div>
        </div>
        {/* Edit Button */}
        <button
          className="text-blue-500 hover:text-blue-600 flex items-center space-x-1 transition-colors duration-300 ease-in-out"
          onClick={toggleModal} // Open modal
        >
          <FaPen className="text-sm sm:text-base" />
          <span>Modify</span>
        </button>
      </div>

      

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 font-lato">
          <div className="bg-white rounded-lg p-6 w-96 shadow-lg">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Modify Trip Details</h2>

            {/* From Location Dropdown */}
            <label className="block mb-2 text-gray-700">From:</label>
            <div className="relative w-full">
              <div
                className="bg-gray-100 rounded-lg px-4 py-3 w-full cursor-pointer flex justify-between items-center"
                onClick={() => setFromDropdownOpen(!fromDropdownOpen)}
              >
                <span>
                  {formData.from
                    ? getLocationName(formData.from)
                    : "Select From Location"}
                </span>
                <svg className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </div>
              {fromDropdownOpen && (
                <div className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-1 shadow-md">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={fromSearch}
                    onChange={(e) => setFromSearch(e.target.value)}
                    className="w-full px-4 py-2 border-b border-gray-300 focus:outline-none"
                  />
                  <div className="max-h-48 overflow-y-auto">
                    {filteredFromLocations.map((location) => (
                      <div
                        key={location?._id}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleLocationChange("from", location?._id)}
                      >
                        {location?.name}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Pickup Street Dropdown */}
            <label className="block mt-4 mb-2 text-gray-700">Pickup Street:</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2 mb-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={formData.pickupStreet}
              onChange={(e) => handleInputChange({ target: { name: "pickupStreet", value: e.target.value } })}
            >
              <option value="">Select Pickup Point</option>
              {all_location.find((location) => location._id === formData.from)?.points?.map((street) => (
                <option key={street?.location} value={street?.location}>
                  {street?.location}
                </option>
              ))}
            </select>

            {/* To Location Dropdown */}
            <label className="block mb-2 text-gray-700">To:</label>
            <div className="relative w-full">
              <div
                className="bg-gray-100 rounded-lg px-4 py-3 w-full cursor-pointer flex justify-between items-center"
                onClick={() => setToDropdownOpen(!toDropdownOpen)}
              >
                <span>
                  {formData.to
                    ? getLocationName(formData.to)
                    : "Select To Location"}
                </span>
                <svg className="h-5 w-5 text-gray-600" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </div>
              {toDropdownOpen && (
                <div className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-1 shadow-md">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={toSearch}
                    onChange={(e) => setToSearch(e.target.value)}
                    className="w-full px-4 py-2 border-b border-gray-300 focus:outline-none"
                  />
                  <div className="max-h-48 overflow-y-auto">
                    {filteredToLocations.map((location) => (
                      <div
                        key={location?._id}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleLocationChange("to", location?._id)}
                      >
                        {location?.name}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Drop Street Dropdown */}
            <label className="block mt-4 mb-2 text-gray-700">Drop Street:</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2 mb-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={formData.dropStreet}
              onChange={(e) => handleInputChange({ target: { name: "dropStreet", value: e.target.value } })}
            >
              <option value="">Select Drop Point</option>
              {all_location.find((location) => location._id === formData.to)?.points?.map((street) => (
                <option key={street?.location} value={street?.location}>
                  {street?.location}
                </option>
              ))}
            </select>

            {/* Date Input */}
            <label className="block mb-2 text-gray-700">Date:</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />

            {/* Buttons */}
            <div className="flex justify-end space-x-2">
              <button
                className="px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
                onClick={toggleModal}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleSaveChanges}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TripDetailsCard;